import type { LangCode } from "@/lib/gql/__generated__/graphql";

import type { MarketingVoucherI18nFormModel } from "../type";

type Props = {
	hotelID: string;
	voucherID: string;
	langCode: LangCode;
	queryData: MarketingVoucherI18nFormModel["QueryData"];
};

export const DEFAULT_PRODUCT_VOUCHER_I18N_INPUT_MODEL = ({ hotelID, voucherID, langCode }: Props) => {
	const inputModel: MarketingVoucherI18nFormModel["InputModel"] = {
		hotelID,
		voucherID,
		lang: langCode,

		name: "",
		description: "",
	} satisfies MarketingVoucherI18nFormModel["InputModel"];

	return inputModel;
};
